import { humanizeSupabaseError } from "@/lib/supabase-errors";

/** Mensagem segura para UI a partir de erros do supabase-js (não vaza SQL/RLS). */
export function formatSupabaseError(err: unknown, fallback: string): string {
  return humanizeSupabaseError(err, { fallback });
}

export function isMissingColumnError(err: unknown, column: string): boolean {
  if (!err || typeof err !== "object") return false;
  const e = err as { code?: string; message?: string };
  const msg = e.message?.toLowerCase() ?? "";
  return (
    e.code === "PGRST204" ||
    msg.includes(column.toLowerCase()) && msg.includes("schema cache")
  );
}
